interface ReadingImportSummary {
  imported: number
  alreadyRead: number
  notFound: number
  exceeding: number
  invalidTimestamp: number
}

const headers: Record<keyof ReadingImportSummary, string> = {
  imported: 'x-import-imported',
  alreadyRead: 'x-import-already-read',
  notFound: 'x-import-not-found',
  exceeding: 'x-import-exceeding',
  invalidTimestamp: 'x-import-invalid-timestamp',
}

const labels: Record<keyof ReadingImportSummary, string> = {
  imported: 'importada(s)',
  alreadyRead: 'já lida(s)',
  notFound: 'não encontrada(s)',
  exceeding: 'excedente(s)',
  invalidTimestamp: 'com timestamp inválido',
}

/**
 * Reads the per-status row counts the API sends back as `X-Import-*` headers.
 */
const readImportSummary = (responseHeaders: Record<string, unknown>): ReadingImportSummary => {
  const count = (header: string) => {
    const value = responseHeaders[header]

    return typeof value === 'string' || typeof value === 'number' ? Number.parseInt(String(value), 10) || 0 : 0
  }

  return {
    imported: count(headers.imported),
    alreadyRead: count(headers.alreadyRead),
    notFound: count(headers.notFound),
    exceeding: count(headers.exceeding),
    invalidTimestamp: count(headers.invalidTimestamp),
  }
}

const describeImportSummary = (summary: ReadingImportSummary): string => {
  const parts = (Object.keys(labels) as (keyof ReadingImportSummary)[])
    .filter(status => summary[status] > 0)
    .map(status => `${summary[status]} ${labels[status]}`)

  return parts.length > 0 ? `${parts.join(', ')}.` : 'Nenhuma linha processada.'
}

export { readImportSummary, describeImportSummary, type ReadingImportSummary }
